import React from "react";
import Select from "react-select";

export default function Picker({ onSelectItem, loading = false, onKeyDown = null, selectedItem = null, multiSelect = false, items, isDisabled = false, name = "", reference = null, onBlur = null }) {

    const customStyles = {
        menu: provided => ({ ...provided, zIndex: 999 })
    };

    //const isLoading = (items !== undefined && items.length > 0) ? false : true;
    return (
        <>
            <Select
                isLoading={loading}
                isDisabled={isDisabled}
                isMulti={multiSelect}
                options={items}
                onChange={(selectedOption) => {
                    onSelectItem(selectedOption);
                }}
                onBlur={onBlur}
                onKeyDown={e => { if (onKeyDown !== null) onKeyDown(e.target.value) }}
                value={selectedItem}
                styles={customStyles}
                theme={theme => ({
                    ...theme,
                    borderRadius: ".375rem",
                    colors: {
                        ...theme.colors,
                        text: "black",
                        primary25: "white",
                        primary: "#1ab394",
                        neutral0: "white"
                    }
                })}
                name={name}
                ref={reference}
                isOptionDisabled={(option) => option.disabled === true}
            />
        </>
    );
}